import Image from "next/image";
import { Box } from "@mui/system";
import { Brand, MediaLogo } from "@/core/types/types";
import getTrustLogosForBrand from "./getTrustLogoForBrand";

type TrustLogosProps = {
  brandName: Brand;
};

export default function TrustLogos({ brandName }: TrustLogosProps) {
  const {
    logos,
    gap,
  }: {
    align: string;
    logos: MediaLogo[];
    gap?: number;
  } = getTrustLogosForBrand(brandName);

  return (
    <Box
      display="flex"
      flexGrow={1}
      flexDirection="column"
      justifyContent={"flex-end"}
      gap={gap}
      paddingBottom={"100px"} // Height of the footer
    >
      {logos.map(({ logo, width, height }) => (
        <Image
          key={logo}
          src={`images/logos/${brandName}/trust/${logo}`}
          alt="trust logo"
          height={height || 40}
          width={width || 180}
        />
      ))}
    </Box>
  );
}
